var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_2595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 -0.00195312C3.58878 -0.00195312 0 3.58683 0 7.99805C0 12.4093 3.58878 15.998 8 15.998C12.4112 15.998 16 12.4093 16 7.99805C16 3.58683 12.4112 -0.00195312 8 -0.00195312ZM8 15.248C4.00234 15.248 0.75 11.9957 0.75 7.99805C0.75 4.00039 4.00234 0.748047 8 0.748047C11.9977 0.748047 15.25 4.00039 15.25 7.99805C15.25 11.9957 11.9977 15.248 8 15.248ZM8 3.16992C5.98953 3.16992 4.35388 4.80555 4.35388 6.81602C4.35388 8.31361 6.14612 10.7396 7.7075 12.6858C7.74263 12.7296 7.78715 12.765 7.83778 12.7893C7.88841 12.8136 7.94385 12.8262 8 12.8262C8.05615 12.8262 8.11159 12.8136 8.16222 12.7893C8.21285 12.765 8.25737 12.7296 8.2925 12.6858L8.34087 12.6255C9.97531 10.5892 11.6461 8.30652 11.6461 6.81602C11.6461 4.80555 10.0105 3.16992 8 3.16992ZM8.00034 11.8508C7.03287 10.6312 5.10388 8.09445 5.10388 6.81602C5.10388 5.21911 6.40306 3.91992 8 3.91992C9.59694 3.91992 10.8961 5.21911 10.8961 6.81602C10.8961 8.1237 8.98203 10.6184 8.00034 11.8508ZM8 4.59298C6.77419 4.59298 5.77694 5.59023 5.77694 6.81605C5.77694 8.04186 6.77422 9.03911 8 9.03911C9.22578 9.03911 10.2231 8.04186 10.2231 6.81605C10.2231 5.59023 9.22581 4.59298 8 4.59298ZM8 8.28908C7.18775 8.28908 6.52694 7.62827 6.52694 6.81602C6.52694 6.00377 7.18775 5.34295 8 5.34295C8.81225 5.34295 9.47306 6.00377 9.47306 6.81602C9.47306 7.62827 8.81225 8.28908 8 8.28908Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_2595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 -0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.63c910a5efda77363878c010c01bfd11.svg";
export { ForwardRef as ReactComponent };